import { Alert, CircularProgress, Stack } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import SnapshotProfileEditor from '../../features/snapshot-profile/SnapshotProfileEditor'
import { useSnapshotProfile } from '../../features/snapshot-profile/useSnapshotProfile'
import type { AvatarBoClient } from '../../shared/types'

export default function SnapshotProfileScreen({ client }: { client: AvatarBoClient }) {
  const { formatMessage } = useIntl()
  const { query, save, apiError } = useSnapshotProfile(client)

  if (query.isLoading) {
    return (
      <Stack alignItems="flex-start" sx={{ p: 2 }}>
        <CircularProgress size={24} />
      </Stack>
    )
  }

  if (query.isError || !query.data) {
    return (
      <Alert severity="error">
        {formatMessage({ id: 'avatarStudio.imageSizes.loadFailed' })}
      </Alert>
    )
  }

  return (
    <SnapshotProfileEditor
      // Remounts on a saved change, so the editor's draft starts from what the server now holds
      // rather than from what was typed - the same trick the tier ladder uses.
      key={`${query.data.sizes.join('|')}/${query.data.scales.join('|')}/${query.data.formats.join('|')}`}
      sizes={query.data.sizes}
      scales={query.data.scales}
      formats={query.data.formats}
      jpegBackground={query.data.jpegBackground}
      isDefault={query.data.isDefault}
      saving={save.isLoading}
      apiError={apiError}
      // tslint:disable-next-line: jsx-no-lambda
      onSave={(input) => save.mutate(input)}
    />
  )
}
